"use client";

// import { CartProvider } from 'use-shopping-cart';
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import { store } from "@/store";
import { UserProvider } from "@/providers/userContext";

const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <Provider store={store}>
        <UserProvider>{children}</UserProvider>
      </Provider>
      <Toaster />
    </>
  );
};

export default Providers;
